<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full">
  <!-- Header -->
  <!-- <div
  class="relative flex items-center w-full h-16 px-4 shadow flex-0 md:px-6 z-49 dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
  <div class="flex items-center">

    <a href="/">
      <img class="w-auto h-auto max-w-50 max-h-15" src="assets/images/logo/logo-primecontrol.png">
    </a>
  </div>
  <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">

    <primecontrol-translations></primecontrol-translations>
    <div class="flex items-center justify-between w-full">
      <user [showAvatar]="false"></user>
    </div>
  </div>
</div> -->

  <!-- Content -->
  <div class="flex flex-col flex-auto">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
  Otherwise, layout changes won't be registered and the view won't be updated! -->
    @if (true) {
      <router-outlet></router-outlet>
    }
  </div>
</div>
